import { useEffect, useState } from "react";
import { Leaf, Menu, X } from "lucide-react";
import { Button } from "../components/ui/button";

const links = [
  { href: "#home", label: "Home" },
  { href: "#about", label: "About" },
  { href: "#why", label: "Why GEES" },
  { href: "#sectors", label: "Sectors" },
  { href: "#services", label: "Services" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-border shadow-[0_1px_0_rgba(0,0,0,0.02)]"
          : "bg-transparent"
      }`}
    >
      <div className="container-wide flex items-center justify-between h-16 lg:h-20">
        <a
          href="#home"
          data-testid="logo-link"
          className="flex items-center gap-2.5 group"
        >
          <img src="/logo.png" alt="Green Earth Energy Solutions" className="h-12 w-auto object-contain" />
        </a>

        <nav className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="px-3.5 py-2 text-sm font-medium text-foreground/80 hover:text-primary transition-colors rounded-md hover:bg-secondary"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            asChild
            data-testid="header-enquire-btn"
            className="bg-primary hover:bg-primary/90 rounded-full px-5"
          >
            <a href="#contact">Enquire Now</a>
          </Button>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-md text-foreground hover:bg-secondary"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-border bg-white"
          data-testid="mobile-nav"
        >
          <nav className="container-wide py-4 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="px-3 py-2.5 text-base font-medium text-foreground hover:text-primary rounded-md hover:bg-secondary"
              >
                {l.label}
              </a>
            ))}
            <Button
              asChild
              data-testid="mobile-enquire-btn"
              className="bg-primary hover:bg-primary/90 mt-2 rounded-full"
            >
              <a href="#contact" onClick={() => setOpen(false)}>
                Enquire Now
              </a>
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
}
